import CryptoJS from 'crypto-js'

// Function to open the database and handle initialization
function openDatabase(dbName, storeName) {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(dbName, 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: 'id' });
      }
    };

    request.onsuccess = (event) => resolve(event.target.result);
    request.onerror = (event) => reject(`Error opening database: ${event.target.errorCode}`);
  });
}

// Function to save JSON data to IndexedDB
export async function saveData(dbName, storeName, id, jsonData) {
  try {
    const db = await openDatabase(dbName, storeName);
    const transaction = db.transaction(storeName, 'readwrite');
    const store = transaction.objectStore(storeName);

    const data = {
      id, data: CryptoJS.AES.encrypt(
        JSON.stringify(jsonData),
        process.env.REACT_APP_PASS
      ).toString()
    };
    store.put(data);

    return new Promise((resolve, reject) => {
      transaction.oncomplete = () => resolve(`Data saved successfully with ID: ${id}`);
      transaction.onerror = (event) => reject(`Error saving data: ${event.target.error}`);
    });
  } catch (error) {
    console.error(error);
  }
}

// Function to delete a record from IndexedDB
export async function deleteData(dbName, storeName, id) {
  try {
    const db = await openDatabase(dbName, storeName);
    const transaction = db.transaction(storeName, 'readwrite');
    const store = transaction.objectStore(storeName);

    return new Promise((resolve, reject) => {
      const request = store.delete(id);
      request.onsuccess = () => resolve(`Data with ID: ${id} deleted successfully`);
      request.onerror = (event) => reject(`Error deleting data: ${event.target.error}`);
    });
  } catch (error) {
    console.error(error);
  }
}

// Function to retrieve JSON data from IndexedDB
async function awaitGetData(dbName, storeName, id) {
  try {
    const db = await openDatabase(dbName, storeName);
    const transaction = db.transaction(storeName, 'readonly');
    const store = transaction.objectStore(storeName);

    return new Promise((resolve, reject) => {
      const request = store.get(id);
      request.onsuccess = () => resolve(request.result);
      request.onerror = (event) => reject(`Error retrieving data: ${event.target.error}`);
    });
  } catch (error) {
    console.error(error);
  }
}

export async function getData(dbName, storeName, id) {
  let data = await awaitGetData(dbName, storeName, id)
  if (data !== null && data !== '' && data !== undefined) {
    try {
      return JSON.parse(
        CryptoJS.AES.decrypt(
          data.data,
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      )
    }
    catch (_) {
      return undefined
    }
  }
  return undefined
}


// WEBPACK FOOTER //
// ./src/views/AudienceBuilder/util/caching/indexdbManager.js